(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  if (!customElements.get('ils-collection-toolbar')) {
    customElements.define('ils-collection-toolbar', class extends HTMLElement {
      connectedCallback() {
        this.header = document.querySelector('.site-header');
        this.controller = new AbortController();
        const options = { signal:this.controller.signal, passive:true };
        this.update = () => {
          this.frame = null;
          let top = 0;
          if (this.header) {
            const position = getComputedStyle(this.header).position;
            if (position === 'fixed' || position === 'sticky') {
              top = Math.max(0, this.header.getBoundingClientRect().bottom);
            }
          }
          const offset = `${Math.round(top)}px`;
          if (offset !== this.offset) {
            this.style.setProperty('--ils-toolbar-top', offset);
            this.offset = offset;
          }
          if (performance.now() < this.transitionUntil) this.schedule();
        };
        this.schedule = () => {
          if (!this.frame) this.frame = requestAnimationFrame(this.update);
        };
        window.addEventListener('scroll', this.schedule, options);
        window.addEventListener('resize', this.schedule, options);
        if (this.header) {
          this.header.addEventListener('transitionrun', () => {
            this.transitionUntil = performance.now() + 500;
            this.schedule();
          }, options);
          this.resizeObserver = new ResizeObserver(this.schedule);
          this.resizeObserver.observe(this.header);
          this.mutationObserver = new MutationObserver(this.schedule);
          this.mutationObserver.observe(this.header, { attributes:true, attributeFilter:['class','style'] });
        }
        this.update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.mutationObserver?.disconnect();
        cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["selected-styles"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ils-selected-styles')) {
  customElements.define('ils-selected-styles', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.selected-styles__track');
      this.controls = this.querySelector('.selected-styles__controls');
      this.buttons = [...this.querySelectorAll('[data-direction]')];
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.update = () => {
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.controls.hidden = max < 2;
        this.buttons[0].disabled = this.track.scrollLeft < 2;
        this.buttons[1].disabled = this.track.scrollLeft >= max - 2;
      };
      this.controls.addEventListener('click', (event) => {
        const button = event.target.closest('[data-direction]');
        if (!button) return;
        const card = this.track.querySelector('.selected-styles__card');
        if (!card) return;
        const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).gap);
        this.track.scrollBy({ left: Number(button.dataset.direction) * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }, options);
      this.track.addEventListener('scroll', this.update, { ...options, passive: true });
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.track);
      this.update();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
